import { WireAdapter } from "lwc";
import debounce from "lodash/debounce";

type Config = {
  debounce: boolean;
  debounceInterval: number;
};

export type ResizeAdapterConfig = Partial<Config>;
export class ResizeAdapter
  implements WireAdapter<void, ResizeAdapterConfig, void> {
  private config: Config = {
    debounce: true,
    debounceInterval: 250,
  };

  private onResize = () => {};

  private setValue: () => void;

  constructor(setValue: () => void) {
    this.setValue = setValue;
  }

  connect() {
    requestAnimationFrame(this.onResize);
  }

  disconnect() {
    window.removeEventListener("resize", this.onResize);
  }

  update(config: ResizeAdapterConfig) {
    this.config = {
      ...this.config,
      ...config,
    };
    window.removeEventListener("resize", this.onResize);
    this.onResize = this.config.debounce
      ? debounce(() => this.setValue(), this.config.debounceInterval)
      : () => this.setValue();
    window.addEventListener("resize", this.onResize);
  }
}
